import {ITheme} from 'contexts/ThemeContext';
import {CreateResponsiveStyle} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle({
    container: {
      width: '100%',
      height: 56,
      backgroundColor: props.colors.dirtyWhite,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingRight: 20,
      paddingLeft: 22,
    },
    screensContainer: {
      flexDirection: 'row',
    },
    itemContainer: {
      marginHorizontal: 8,
      paddingHorizontal: 8,
      height: 56,
      justifyContent: 'center',
    },
    text: {
      fontSize: 14,
      fontWeight: '500',
      color: props.colors.pickledBluewood,
    },
    activeLine: {
      width: '100%',
      height: 2,
      backgroundColor: props.colors.purple(1),
      borderRadius: 1,
      position: 'absolute',
      bottom: 0,
      left: 0,
    },
  })();
